import {useMutation} from '@tanstack/react-query'
import {MUTATION_KEYS} from './keys'
import {sendChatFile, SendFilePayload} from '../services/chat.http'
import axios from 'axios'
import {useSendMessageV3} from './useSendMessageV3'
import {MessageTypeE} from '../chat.model'
import {useMe} from '@/features/authentication/queries/useMe'
import {UserRoleE} from '@/types'
import {LocalStorageManager} from '@/utilities/localStorage'

export const useSendChatFileV3 = (chatIdentifier: string, onSuccess?: () => void) => {
    const {data: user} = useMe()
    const isRepresentative = user?.type === UserRoleE.Representative
    const representedCreatorId = isRepresentative ? LocalStorageManager.chatUserId.get() : undefined

    const {mutateAsync} = useSendMessageV3({chatIdentifier})

    return useMutation({
        mutationKey: [MUTATION_KEYS.send_file],
        mutationFn: async ({
            payload,
            file,
            senderId,
            receiverId,
            metadata = {}
        }: {
            payload: SendFilePayload
            file: File
            senderId: number
            receiverId: number
            metadata?: {
                morgiAmount?: number
            }
        }) => {
            const resPreLink = await sendChatFile({
                ...payload,
                ...(representedCreatorId && {representedCreatorId})
            })

            if (resPreLink.url) {
                const formData = new FormData()
                Object.entries(resPreLink.fields).forEach(([key, value]) => {
                    formData.append(key, value as string)
                })
                formData.append('file', file)

                const resUploadedFile = await axios.post(resPreLink.url, formData)

                const messagePayload = {
                    message: {
                        type: payload.fileType as unknown as MessageTypeE,
                        senderId,
                        receiverId,
                        metadata
                    },
                    fileUploadId: resPreLink.fileUploadId
                }

                await mutateAsync(messagePayload)
                return {resPreLink, resUploadedFile}
            }
        },
        onSettled: () => {
            onSuccess?.()
        }
    })
}
